import React, { useEffect, useState } from 'react'
import axios from 'axios'
import ComicReview from '../../Components/Comic/ComicReview'
import { Pagination } from 'react-bootstrap'

const index = () => {
  const [approveYn, setApproveYn] = useState('P')
  const [pageNumber, setPageNumber] = useState(1)
  const [pageMap, setPageMap] = useState({})
  const [comicList, setComicList] = useState([])

  useEffect(() => {
    getComic()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber, approveYn])

  const changeApproveYn = value => {
    setApproveYn(value)
    setPageNumber(1)
  }

  const getComic = async n => {
    const isPrivateTab = approveYn === 'private'
    const apiApproveYn = isPrivateTab ? 'all' : approveYn
    const apiPublicYn = isPrivateTab ? 'N' : 'Y'

    await axios
      .get(
        `/new/webAdmin/v2/comic?approveYn=${apiApproveYn}&publicYn=${apiPublicYn}&status=done&pageNumber=${
          n ? n : pageNumber
        }&limit=20`,
        {
          headers: {
            token: sessionStorage.getItem('token'),
          },
        }
      )
      .then(({ data }) => {
        setComicList(data.body.list || [])
        setPageMap(data.body.pageMap || {})
      })
      .catch(err => {
        console.error('[comic] error:', err)
      })
  }

  const updateComicApprove = async (seq, approveYn) => {
    await axios
      .put(
        `/new/webAdmin/v2/comic/${seq}/approve`,
        { approveYn },
        {
          headers: {
            token: sessionStorage.getItem('token'),
          },
        }
      )
      .then(() => {
        getComic()
      })
      .catch(err => {
        console.error('[comic/approve] error:', err)
        const msg =
          (err.response && err.response.data && err.response.data.message) ||
          err.message
        window.alert((approveYn === 'Y' ? '승인' : '거절') + ' 실패: ' + msg)
      })
  }

  const fetchComicCuts = async seq => {
    return await axios
      .get(`/new/webAdmin/v2/comic/${seq}/cuts`, {
        headers: {
          token: sessionStorage.getItem('token'),
        },
      })
      .then(({ data }) => data.body.list || [])
      .catch(err => {
        console.error('[comic/cuts] error:', err)
        return []
      })
  }

  const renderPaging = (pageNumber, pageMap) => {
    let list = []
    let j = 0
    let i = 0

    let test = pageNumber !== 1 ? pageNumber - 1 : 1
    let last =
      pageNumber !== pageMap.pageCount ? pageNumber * 1 + 1 : pageMap.pageCount

    list.push(
      <Pagination.Item
        key="first"
        onClick={() => {
          setPageNumber(test)
        }}
      >
        &laquo;
      </Pagination.Item>
    )

    for (i = pageMap.startPage * 1; i <= pageMap.endPage; i++) {
      let num = pageMap.startPage * 1 + j

      if (num === pageMap.pageNumber * 1) {
        list.push(
          <Pagination.Item key={i} className="active">
            {num}
          </Pagination.Item>
        )
      } else {
        list.push(
          <Pagination.Item
            key={i}
            onClick={() => {
              setPageNumber(num)
            }}
          >
            {num}
          </Pagination.Item>
        )
      }
      j++
    }

    list.push(
      <Pagination.Item
        key="last"
        onClick={() => {
          setPageNumber(last)
        }}
      >
        &raquo;
      </Pagination.Item>
    )
    return <Pagination>{list}</Pagination>
  }

  return (
    <>
      <ComicReview
        comicList={comicList}
        approveYn={approveYn}
        setApproveYn={changeApproveYn}
        updateComicApprove={updateComicApprove}
        fetchComicCuts={fetchComicCuts}
        refresh={() => getComic()}
      />
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        {pageMap && pageMap.pageCount ? renderPaging(pageNumber, pageMap) : null}
      </div>
    </>
  )
}

export default index
